import { closeBrackets } from '@codemirror/autocomplete';

const BracketInserter = closeBrackets;

export default BracketInserter;
